import { useState } from "react";

const useDataTableSort = (initialField = "", initialDirection = "desc") => {
    const [sortField, setSortField] = useState(initialField);
    const [sortDirection, setSortDirection] = useState(initialDirection);

    const handleSort = (column, direction) => {
        const newField = column.selector || column.id;
        
        let newDirection = direction;
        if (sortField === newField) {
            newDirection = sortDirection === "desc" ? "asc" : "desc";
        }
        
        setSortField(newField);
        setSortDirection(newDirection);
    };

    return {
        sortField,
        sortDirection,
        handleSort
    };
};

export default useDataTableSort;